export default class Constants {
  /**
   * the default value for the coefficient that does not contain any option (not set in administration or the coefficient have an exception)
   */
  public static readonly DEFAULT_VALUE_EMPTY_OPTIONS: string = "void";
  public static readonly DEFAULT_WAIT_ERROR_NOTIFICATIONS: number = 10000;
}
